import { gql } from "@apollo/client";

export const INSPECTION_ORDERS_QUERY = gql`
query InspectionOrders($filter: InspectionOrderFilter) { 
    inspectionOrders( 
        filter: $filter
    ) { 
        id 
        name 
        locationDescription 
        assetDescription
        dueDate 
        assignedBy 
        approvedBy 
        approvedDate 
        completedBy 
        completedDate 
        status 
        options 
        source
        cadenceLabel
        cadenceInterval
        locationId
        obligationId
        productCategoryId
        generationKey
        periodStart
        createdAt 
        updatedAt 
        deletedAt 
        assignedByUser { 
            id 
            email 
            firstName 
            lastName 
            role 
        } 
        approvedByUser { 
            id 
            email 
            firstName 
            lastName 
            role 
        } 
        assets {
            id
            inspectionStatus
        }
    } 
}
`;

export const INSPECTION_ORDER_QUERY = gql`
query InspectionOrder($id: ID!) { 
    inspectionOrder(id: $id) { 
        id 
        name 
        locationDescription 
        assetDescription
        dueDate 
        approvedDate 
        completedBy 
        completedDate 
        status 
        options 
        source
        cadenceLabel
        cadenceInterval
        locationId
        obligationId
        productCategoryId
        generationKey
        periodStart
        assignedByUser { 
            id 
            email 
            firstName 
            lastName 
            role 
        } 
        approvedByUser { 
            id 
            email 
            firstName 
            lastName 
            role 
        } 
        assignedBy 
        approvedBy 
        location {
            id
            locationName
            address
            city
            state
        }
        obligation {
            obligationId
            obligation
            description
            type
            evidences
            jurisdictions
            status
        }
        obligations {
            obligationId
            obligation
            description
            type
            evidences
            jurisdictions
            status
            locationId
            productId
            productTypeId
            assetId
        }
        assets { 
            id
            assetId 
            inspectionOrderId 
            inspectionStatus 
            userNotes 
            attachments 
            approvedBy 
            approverNotes 
            completedBy 
            completedAt
            assets { 
                name 
                id 
                description
                information
                serialNumber 
                installationDate 
                locationAddress 
                upcomingInspection
                locationIds
                productId
                locations {
                    id
                    locationName
                    locationType
                    locationTypeName
                    parentId
                }
                files { 
                    id 
                    file_name 
                    file_url 
                    belongs_to_type 
                    belongs_to_id 
                    mime_type 
                }
                product { 
                    id 
                    category { 
                        name 
                        iconColor 
                    }
                    type { 
                        name 
                        id 
                        iconColor 
                    }
                    name 
                }
            }
        } 
    } 
}
`;

export const INSPECTION_EVIDENCE_FORM_QUERY = gql`
  query InspectionEvidenceForm($inspectionOrderId: ID!, $assetId: ID!) {
    inspectionEvidenceForm(inspectionOrderId: $inspectionOrderId, assetId: $assetId) {
      id
      inspectionOrderId
      assetId
      periodStart
      status
      schemaVersion
      exportDocumentId
      submittedAt
      tickets {
        id
        code
        title
        description
        evidenceLabel
        documentType
        coveredObligationIds
        questions
        answers
        result
        sortOrder
        required
        supportingDocumentRequired
        minAttachments
        evidenceType
        attachments {
          id
          documentId
          attachmentRole
          questionId
        }
      }
    }
  }
`;
